import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Home from "../pages/home/home";
import Join from "../pages/join/join";
import JoinComplete from "../pages/join/joinComplete";
import Login from "../pages/login/login";
import AdminEdit from "../pages/manager/adminEdit";
import Manager from "../pages/manager/manager";
import ManagerDetail from "../pages/manager/managerDetail";
import RootEdit from "../pages/manager/rootEdit";
import CommonMember from "../pages/user/commonMember/commonMember";
import CommonMemberDetail from "./../pages/user/commonMember/commonMemberDetail";
import CommonMemberEdit from "./../pages/user/commonMember/commonMemberEdit";
import LeaveMember from "./../pages/user/leaveMember/leaveMember";
import { route } from "./route";
import MainBanner from "../pages/service/banner/mainBanner";
import FinanceBanner from "./../pages/service/banner/financeBanner";
import Popup from "./../pages/service/popup/popup";
import PopupDetail from "./../pages/service/popup/popupDetail";
import PopupEdit from "./../pages/service/popup/popupEdit";
import PopupCreate from "./../pages/service/popup/popupCreate";
import Basic from "./../pages/service/basic/basic";
import BasicEdit from "./../pages/service/basic/basicEdit";
import Terms from "./../pages/service/terms/terms";
import TermsEdit from "./../pages/service/terms/termsEdit";
import TermsDetail from "./../pages/service/terms/termsDetail";
import Alarm from "./../pages/service/alarm/alarm";
import AlarmDetail from "./../pages/service/alarm/alarmDetail";
import AlarmCreate from "./../pages/service/alarm/alarmCreate";
import Faq from "./../pages/cs/faq/faq";
import FaqDetail from "./../pages/cs/faq/faqDetail";
import FaqAdd from "./../pages/cs/faq/faqAdd";
import FaqEdit from "./../pages/cs/faq/faqEdit";
import Ask from "./../pages/cs/ask/ask";
import Notice from "./../pages/cs/notice/notice";
import NoticeDetail from "./../pages/cs/notice/noticeDetail";
import NoticeCreate from "./../pages/cs/notice/noticeCreate";
import ColumnCategory from "../pages/column/category/columnCategory";
import ColumnCategoryDetail from "../pages/column/category/columnCategoryDetail";
import ColumnCategoryEdit from "../pages/column/category/columnCategoryEdit";
import ColumnCategoryAdd from "../pages/column/category/columnCategoryAdd";
import ColumnPost from "../pages/column/post/columnPost";
import ColumnPostDetail from "../pages/column/post/columnPostDetail";
import ColumnPostEdit from "../pages/column/post/columnPostEdit";
import ColumnPostAdd from "../pages/column/post/columnPostAdd";
import CommunityCategory from "../pages/community/category/communityCategory";
import CommunityCategoryDetail from "../pages/community/category/communityCategoryDetail";
import CommunityCategoryAdd from "../pages/community/category/communityCategoryAdd";
import CommunityPost from "../pages/community/post/communityPost";
import CommunityPostDetail from "../pages/community/post/communityPostDetail";
import PostReport from "../pages/community/report/postReport";
import CommentReport from "../pages/community/report/commentReport";
import CommentReportDetail from "../pages/community/report/commentReportDetail";
import PostReportDetail from "../pages/community/report/postReportDetail";
import Pay from "../pages/payment/pay/pay";
import PayDetail from "../pages/payment/pay/payDetail";
import Refund from "../pages/payment/refund/refund";
import RefundDetail from "../pages/payment/refund/refundDetail";
import CouponIssuance from "../pages/payment/coupon/couponIssuance";
import CouponHistory from "../pages/payment/coupon/couponHistory";
import Subscribe from "../pages/payment/subscribe/subscribe";
import SubscribeDetail from "../pages/payment/subscribe/subscribeDetail";
import SubscribeSetting from "../pages/payment/subscribe/subscribeSetting";
import FinanceCategory from "../pages/lecture/category/financeCategory";
import PaidCategory from "../pages/lecture/category/paidCategory";
import LectureCategoryAdd from "../pages/lecture/category/lectureCategoryAdd";
import LectureCategoryEdit from "../pages/lecture/category/lectureCategoryEdit";
import LectureCategoryDetail from "../pages/lecture/category/lectureCategoryDetail";
import ConsultingProduct from "../pages/consulting/product/consultingProduct";
import ConsultingDetail from "../pages/consulting/product/consultingDetail";
import ConsultingReview from "../pages/consulting/product/consultingReview";
import ConsultingAdd from "../pages/consulting/product/consultingAdd";
import ConsultingEdit from "../pages/consulting/product/consultingEdit";
import PriorForm from "../pages/consulting/form/priorForm";
import PriorFormDetail from "../pages/consulting/form/priorFormDetail";
import RequiredForm from "../pages/consulting/form/requiredForm";
import RequiredFormDetail from "../pages/consulting/form/requiredFormDetail";
import OnBoarding from "../pages/lecture/onBoarding/onBoarding";
import OnBoardingDetail from "../pages/lecture/onBoarding/onBoardingDetail";
import FinanceLecture from "../pages/lecture/lecture/financeLecture";
import PaidLecture from "../pages/lecture/lecture/paidLecture";
import LectureDetail from "../pages/lecture/lecture/lectureDetail";
import LectureCurriculum from "../pages/lecture/lecture/lectureCurriculum";
import LectureReview from "../pages/lecture/lecture/lectureReview";
import LectureAdd from "../pages/lecture/lecture/lectureAdd";
import CurriculumEdit from "../pages/lecture/lecture/curriculumEdit";
import LectureEdit from "../pages/lecture/lecture/lectureEdit";
import CommunityCategoryEdit from "../pages/community/category/communityCategoryEdit";
import CurriculumAdd from "../pages/lecture/lecture/curriculumAdd";

const Router = () => {
  return (
    <Routes>
      {/* ----- 기본 ----- */}
      <Route path={route.default} element={<Login />} />
      <Route path={route.login} element={<Login />} />
      <Route path={route.join} element={<Join />} />
      <Route path={route.join_complete} element={<JoinComplete />} />

      {/* ----- 홈 ----- */}
      <Route path={route.home} element={<Home />} />

      {/* ----- 사용자 관리 ----- */}
      <Route path={route.user_common_member} element={<CommonMember />} />
      <Route path={route.user_common_member_detail + "/:id"} element={<CommonMemberDetail />} />
      <Route path={route.user_common_member_edit + "/:id"} element={<CommonMemberEdit />} />
      <Route path={route.user_leave_member} element={<LeaveMember />} />

      {/* ----- 강의 관리 ----- */}
      <Route path={route.lecture_category_finance} element={<FinanceCategory />} />
      <Route path={route.lecture_category_paid} element={<PaidCategory />} />
      <Route path={route.lecture_category_add} element={<LectureCategoryAdd />} />
      <Route path={route.lecture_category_edit + "/:id"} element={<LectureCategoryEdit />} />
      <Route path={route.lecture_category_detail + "/:id"} element={<LectureCategoryDetail />} />
      <Route path={route.lecture_lecture_finance} element={<FinanceLecture />} />
      <Route path={route.lecture_lecture_paid} element={<PaidLecture />} />
      <Route path={route.lecture_lecture_info + "/:id"} element={<LectureDetail />} />
      <Route path={route.lecture_lecture_curriculum + "/:id"} element={<LectureCurriculum />} />
      <Route path={route.lecture_lecture_review + "/:id"} element={<LectureReview />} />
      <Route path={route.lecture_lecture_add} element={<LectureAdd />} />
      <Route path={route.lecture_lecture_edit + "/:id"} element={<LectureEdit />} />
      <Route path={route.lecture_lecture_curriculum_edit + "/:id"} element={<CurriculumEdit />} />
      <Route path={route.lecture_lecture_curriculum_add + "/:id"} element={<CurriculumAdd />} />
      <Route path={route.lecture_onboarding} element={<OnBoarding />} />
      <Route path={route.lecture_onboarding_detail + "/:id"} element={<OnBoardingDetail />} />

      {/* ----- 결제 관리 ----- */}
      <Route path={route.payment_pay} element={<Pay />} />
      <Route path={route.payment_pay_detail + "/:id"} element={<PayDetail />} />
      <Route path={route.payment_refund} element={<Refund />} />
      <Route path={route.payment_refund_detail + "/:id"} element={<RefundDetail />} />
      <Route path={route.payment_coupon_issuance} element={<CouponIssuance />} />
      <Route path={route.payment_coupon_history} element={<CouponHistory />} />
      <Route path={route.payment_subscribe_list} element={<Subscribe />} />
      <Route path={route.payment_subscribe_detail + "/:id"} element={<SubscribeDetail />} />
      <Route path={route.payment_subscribe_setting} element={<SubscribeSetting />} />

      {/* ----- 커뮤니티 관리 ----- */}
      <Route path={route.community_report_comment} element={<CommentReport />} />
      <Route path={route.community_report_post} element={<PostReport />} />
      <Route path={route.community_report_comment_detail + "/:id"} element={<CommentReportDetail />} />
      <Route path={route.community_report_post_detail + "/:id"} element={<PostReportDetail />} />

      <Route path={route.community_post} element={<CommunityPost />} />
      <Route path={route.community_post_detail + "/:id"} element={<CommunityPostDetail />} />
      <Route path={route.community_category} element={<CommunityCategory />} />
      <Route path={route.community_category_detail + "/:id"} element={<CommunityCategoryDetail />} />
      <Route path={route.community_category_edit + "/:id"} element={<CommunityCategoryEdit />} />
      <Route path={route.community_category_add} element={<CommunityCategoryAdd />} />

      {/* ----- 칼럼 관리 ----- */}
      <Route path={route.column_post} element={<ColumnPost />} />
      <Route path={route.column_post_detail + "/:id"} element={<ColumnPostDetail />} />
      <Route path={route.column_post_edit + "/:id"} element={<ColumnPostEdit />} />
      <Route path={route.column_post_add} element={<ColumnPostAdd />} />
      <Route path={route.column_category} element={<ColumnCategory />} />
      <Route path={route.column_category_detail + "/:id"} element={<ColumnCategoryDetail />} />
      <Route path={route.column_category_edit + "/:id"} element={<ColumnCategoryEdit />} />
      <Route path={route.column_category_add} element={<ColumnCategoryAdd />} />

      {/* ----- 컨설팅 관리 ----- */}
      <Route path={route.consulting_product} element={<ConsultingProduct />} />
      <Route path={route.consulting_add} element={<ConsultingAdd />} />
      <Route path={route.consulting_edit + "/:id"} element={<ConsultingEdit />} />
      <Route path={route.consulting_detail_info + "/:id"} element={<ConsultingDetail />} />
      <Route path={route.consulting_detail_review + "/:id"} element={<ConsultingReview />} />
      <Route path={route.consulting_form_prior} element={<PriorForm />} />
      <Route path={route.consulting_form_prior_detail + "/:id"} element={<PriorFormDetail />} />
      <Route path={route.consulting_form_required} element={<RequiredForm />} />
      <Route path={route.consulting_form_required_detail + "/:id"} element={<RequiredFormDetail />} />

      {/* ----- 고객센터 관리 ----- */}
      <Route path={route.cs_notice} element={<Notice />} />
      <Route path={route.cs_notice_detail + "/:id"} element={<NoticeDetail />} />
      <Route path={route.cs_notice_create} element={<NoticeCreate />} />

      <Route path={route.cs_ask} element={<Ask />} />

      <Route path={route.cs_faq} element={<Faq />} />
      <Route path={route.cs_faq_detail + "/:id"} element={<FaqDetail />} />
      <Route path={route.cs_faq_edit + "/:id"} element={<FaqEdit />} />
      <Route path={route.cs_faq_create} element={<FaqAdd />} />

      {/* ----- 서비스 관리 ----- */}
      <Route path={route.service_alarm} element={<Alarm />} />
      <Route path={route.service_alarm_detail + "/:id"} element={<AlarmDetail />} />
      <Route path={route.service_alarm_create} element={<AlarmCreate />} />

      <Route path={route.service_terms} element={<Terms />} />
      <Route path={route.service_terms_detail + "/:id"} element={<TermsDetail />} />
      <Route path={route.service_terms_edit + "/:id"} element={<TermsEdit />} />

      <Route path={route.service_basic} element={<Basic />} />
      <Route path={route.service_basic_edit} element={<BasicEdit />} />

      <Route path={route.service_popup} element={<Popup />} />
      <Route path={route.service_popup_detail + "/:id"} element={<PopupDetail />} />
      <Route path={route.service_popup_edit + "/:id"} element={<PopupEdit />} />
      <Route path={route.service_popup_create} element={<PopupCreate />} />

      <Route path={route.service_banner_main} element={<MainBanner />} />
      <Route path={route.service_banner_finance} element={<FinanceBanner />} />

      {/* ----- 관리자회원 관리 ----- */}
      <Route path={route.manager} element={<Manager />} />
      <Route path={route.manager_detail + "/:id"} element={<ManagerDetail />} />
      <Route path={route.manager_edit_root + "/:id"} element={<RootEdit />} />
      <Route path={route.manager_edit_admin + "/:id"} element={<AdminEdit />} />

      <Route path="*" element={<Navigate to={route.default} replace />} />
    </Routes>
  );
};

export default Router;
